import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import "@/plugins/validation";
import filters from "@/filters";
import MoneySpinner from "v-money-spinner";
import IdleVue from "idle-vue";
import { IDLE_TIME } from "@/constants/common.constants";

Vue.use(VueMask);
Vue.use(MoneySpinner);
Vue.config.productionTip = false;
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: IDLE_TIME,
});

new Vue({
  router,
  store,
  vuetify,
  filters,
  render: (h) => h(App),
}).$mount("#app");

window.loadDummyData = function (dummyData) {
  store.dispatch("questions/loadDummyData", dummyData);
  store.dispatch("application/loadDummyData", dummyData);
};
